<!-- toolbar -->
<span class="view-container">
  <mat-toolbar class="view-toolbar" *ngIf="!showWelcome">
    <mat-toolbar-row>
      <!-- document-selected-header-info -->
      <div class="view-description" *ngIf="doc && showFileDocumentHeader">
        <button
          fxLayout="row"
          fxLayoutAlign="center center"
          *ngIf="floatingMode"
          class="show-md"
          mat-icon-button
          (click)="goBack()"
          title="{{ 'fileDocuments.fileDocumentDetail.backToListTooltip' | transloco }}"
        >
          <mat-icon
            fxLayout="row"
            fxLayoutAlign="center center"
            class="fa-lg"
            fontSet="fa"
            fontIcon="fa-arrow-left"
          >
          </mat-icon>
        </button>
        <mat-icon
          fxLayout="row"
          fxLayoutAlign="center center"
          class="hide-md fa-lg"
          fontSet="fa"
          fontIcon="fa-file"
        >
        </mat-icon>
        <div
          class="view-description-text"
          fxLayout="column"
          fxLayoutAlign="center start"
        >
          <h3 matLine [title]="doc.documentationTypeName">
            {{ doc.documentationTypeName }}
          </h3>
          <h5 matLine>
            {{ 'common.idLbl' | transloco }}{{ doc.id }} - {{ 'common.documentDateLbl' | transloco }}:
            {{ doc.documentDate | date: "dd/MM/yyyy" }}
          </h5>
        </div>
      </div>
      <!-- close-detail-mobile-only -->
      <button
        id="closeDetail"
        mat-icon-button
        (click)="this.mobileClose()"
        title="{{ 'common.closeBtn' | transloco }}"
      >
        <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
      </button>
      <div class="view-actions">
        <div fxLayout="row" fxLayoutAlign="end center">
          <button
            mat-stroked-button
            class="nom151-evidence-button"
            type="button"
            (click)="verEvidenciasdeFirmas(doc)"
            *ngIf="showNom151 && doc?.documentFileSignaturesData?.length > 0 && doc.documentFileSignaturesData[0]?.proveDocumentId != null"
            [matTooltip]="'fileDocuments.fileDocumentDetail.viewNom151EvidenceTooltip' | transloco"
            [attr.aria-label]="'fileDocuments.fileDocumentDetail.viewNom151EvidenceTooltip' | transloco"
          >
            <mat-icon fontSet="fa" fontIcon="fa-file-certificate"></mat-icon>
            <span>{{ 'fileDocuments.fileDocumentDetail.nom151EvidenceBtn' | transloco }}</span>
          </button>
          <!-- PDF-controls -->
          <app-pdf-wrapper-controls
            *ngIf="!isZip"
            [pdfWrapper]="pdfWrapper"
            [showPrint]="showPrint"
            [showSave]="showSave"
            [showZoomIn]="showZoomIn && filePdf"
            [showZoomOut]="showZoomOut && filePdf"
            [(showRemove)]="showRemove"
            (OnRemoveFile)="removeFile()"
          >
          </app-pdf-wrapper-controls>
          <!--cancel-document -->
          <button
            mat-icon-button
            *ngIf="showCancel && canCancel && !doc.isCanceled()"
            (click)="cancelFileDocument()"
            title="{{ 'common.rejectDocumentBtn' | transloco }}"
          >
            <mat-icon
              class="fa-lg"
              fontSet="fa"
              fontIcon="fa-file-times"
            ></mat-icon>
          </button>
          <!-- delete-document -->
          <button
            *ngIf="canDelete && showDelete"
            mat-icon-button
            (click)="deleteFileDocument()"
            title="{{ 'common.deleteDocumentBtn' | transloco }}"
          >
            <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-trash"></mat-icon>
          </button>
          <!-- metadata-view -->
          <button
            mat-icon-button
            (click)="this.showMetadatos()"
            title="{{ 'common.seeMoreDataBtn' | transloco }}"
            *ngIf="showMetadatas"
          >
            <mat-icon
              class="fa-lg"
              fontSet="fa"
              fontIcon="fa-file-alt"
            ></mat-icon>
          </button>
          <!-- view rejected motive -->
          <button
            id="btnViewMotie"
            mat-icon-button
            (click)="canceledChapa = true"
            title="{{ 'common.seeRejectionReasonLbl' | transloco }}"
            *ngIf="doc.isCanceled() && !canceledChapa"
          >
            <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-eye"></mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <!-- Todos los modulos -->
  <span class="view-content">
    <!-- LOADER -->
    <div class="window-spinner" *ngIf="showSpinner">
      <mat-progress-spinner mode="indeterminate" color="primary">
      </mat-progress-spinner>
    </div>
    <!-- formio -->
    @defer (when (documentationType?.isExternalFormOnly || showFormio) && allowsFormio && !doc?.hasFiles) {
      @if ((documentationType?.isExternalFormOnly || showFormio) && allowsFormio && !doc?.hasFiles) {
        <span class="formio-content">
          <app-formio-cardinal [haveCloseAction]="false" (submitted)="submitFormio($event)"
            [formName]="documentationType?.exteralForm" [fileDocument]="doc">
          </app-formio-cardinal>
          <div class="firmador">
            <button mat-raised-button class="content-action-main" (click)="accion()" color="accent" fxLayout="row"
              fxLayoutAlign="center center" [ngClass]="{'disabled' : saving}">
              <mat-icon [ngClass]="saving ? 'fa-xs fa-spin' : 'fa-lg'" fontSet="fa"
                [fontIcon]="saving ? 'fa-spinner-third' : 'fa-file-export'"></mat-icon>
              <span>{{saving ? ('common.loading' | transloco) : ('common.send' | transloco)}}</span>
            </button>
          </div>
        </span>
      }
    }
    <!-- PDF-viewer -->
    <app-pdf-wrapper
      [showControls]="false"
      #pdfWrapper
      [doc]="doc"
      [file]="filePdf"
      [fileBlob]="fileBlob"
      [fileName]="fileName"
      [autoView]="false"
      [showAll]="showAll"
      [autoSize]="autoSizeDoc"
      [hidden]="showChapa || showSpinner || canceledChapa"
    >
    </app-pdf-wrapper>
    <div class="actions-footer-wrapper">
      <div class="actions-footer-container" [class.flow-active]="isQueryActive">
        <app-file-document-query
          *ngIf="doc && !showSpinner"
          [doc]="doc"
          [showQuery]="showQuery"
          [organizationalUnitId]="doc?.organizationalUnitId"
          (closedQuery)="closedQuery.emit($event)"
          (activeChange)="isQueryActive = $event"
          (queryChanged)="doc.hasMessage = $event"
        >
        </app-file-document-query>
      </div>
    </div>
    <app-chapa
      [className]="'upload-bk'"
      [text]="'employee.pendingUploadLbl' | transloco"
      *ngIf="doc?.isUploadPending() && !doc?.isCanceled()"
    >
    </app-chapa>
    <app-chapa
      *ngIf="showWelcome"
      [className]="'info-empty'"
      [icon]="'fa-hand-sparkles'"
      [text]="'employee.welcomeMessageLbl' | transloco"
      [subText]="'employee.welcomeMessageSubtitleLbl' | transloco"
    >
    </app-chapa>
    <app-chapa
      [className]="'info-empty'"
      [icon]="'fa-file-times'"
      [text]="'employee.rejectedDocumentLbl' | transloco"
      [subText]="doc.rejectedMotive ? ('defferedProcess.reasonLbl' | transloco) : ''"
      [infoExtra]="doc.rejectedMotive"
      [actionIcon]="'fa-eye'"
      [actionText]="'common.seeDocumentLbl' | transloco"
      (actionClick)="hideChapa()"
      *ngIf="canceledChapa"
    ></app-chapa>
  </span>
</span>
